<template>
	<div class="flex w-full justify-center">
		<div class="w-full overflow-x-hidden overscroll-y-none touch-pan-x touch-pan-y p-4 max-w-4xl">
			<div class="flex w-full justify-center text-3xl text-ihh-midnight-gray font-semibold mb-12">Help Center</div>
			<!---Quick Help-->
			<div class="flex justify-center font-sans mb-4">
				<div class="bg-ihh-pink w-full rounded-2xl p-12 text-ihh-slate-gray">
					<div class="flex justify-around font-semibold text-2xl md:text-4xl tracking-wide text-ihh-midnight-gray/90">Quick Help</div>
					<div class="grid grid-cols-1 md:grid-cols-2 gap-12 pt-10 justify-around tracking-wide text-lg md:text-quick-help">
						<a
							v-for="(help, index) in quickHelp"
							:key="index"
							class="hover:underline w-full mt-2 flex flex-col items-center justify-end"
							style="text-decoration: none"
							:href="help.link"
						>
							<div class="flex w-full justify-center px-12">
								<div
									class="mb-4 w-full max-w-24 aspect-square bg-center bg-contain bg-no-repeat text-transparent hover:scale-110 active:scale-90"
									:style="{ backgroundImage: `url(${help.img})` }"
								/>
							</div>
							<div>{{ help.title }}</div>
						</a>
					</div>
				</div>
			</div>

			<!---We're here to help-->
			<div class="flex justify-center font-sans">
				<div class="bg-ihh-pink w-full rounded-2xl p-12 text-ihh-slate-gray">
					<h1 class="flex justify-around font-semibold text-2xl md:text-4xl tracking-wide text-ihh-midnight-gray/90">We're here to help</h1>

					<div class="grid grid-cols-1 md:grid-cols-2 gap-8 py-10 justify-around tracking-wide text-lg md:text-quick-help">
						<button
							v-for="(here, index) in hereToHelp"
							:key="index"
							type="button"
							class="hover:underline w-full mt-2 flex flex-col items-center justify-start"
							style="text-decoration: none"
							@click="here.action"
						>
							<div
								class="mb-4 w-full max-w-24 aspect-square bg-center bg-contain bg-no-repeat text-transparent hover:scale-110 active:scale-90"
								:style="{ backgroundImage: `url(${here.img})` }"
							/>
							<div class="py-2">{{ here.title }}</div>
							<div v-show="here.live">
								<div class="text-xs md:text-base uppercase font-semibold italic text-ihh-dark-salmon flex items-center justify-center">
									Fastest Response
									<img class="w-7" src="https://store-nuj3c.mybigcommerce.com/product_images/help-center/fast.png" alt="" />
								</div>
							</div>
							<div class="text-xs md:text-lg font-semibold flex text-center items-center">{{ here.subtitle }}</div>
							<div v-show="here.sub" class="italic text-xs md:text-lg font-semibold flex text-center items-center">
								800-247-4045 <br />
								10am-4pm CST
							</div>
							<div v-show="here.message" class="italic text-xs md:text-lg font-semibold flex text-center items-center">{{ here.message }}</div>
						</button>
					</div>
				</div>
			</div>

			<div class="flex flex-col w-full justify-center mt-6">
				<div class="mt-6 mb-0 pb-0">
					<div class="flex w-full text-start text-4xl text-ihh-midnight-gray font-semibold mb-2">Message Us</div>
					<div class="text-base text-ihh-slate-gray italic">Please chat with us or send us a message using the form below. We look forward to helping you!</div>
				</div>
				<!-- Gorgias Form START -->
				<iframe src="/gorgias.html" class="w-full h-[900px] border-none" style="border: none; width: 70%; height: 900px" title="Gorgias Form"></iframe>
				<!-- Gorgias Form END -->
			</div>

			<div class="mb-12 mt-24 space-y-4">
				<div class="flex w-full text-start text-4xl text-ihh-midnight-gray font-semibold mb-2">Write us by mail</div>
				<div class="text-lg text-ihh-slate-gray">P.O. Box 467 Liberty Hill, TX 78642</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['store'],
	data() {
		return {
			quickHelp: [
				{
					img: 'https://store-nuj3c.mybigcommerce.com/product_images/help-center/cropped/shipping-min-3.png',
					title: 'Shipping',
					link: '/shipping-info/',
				},
				{
					img: 'https://store-nuj3c.mybigcommerce.com/product_images/help-center/cropped/return-min-3.png',
					title: 'Returns',
					link: '/returns',
				},
				{
					img: 'https://store-nuj3c.mybigcommerce.com/product_images/help-center/cropped/kit-order-min-3.png',
					title: 'Order Birth Kit',
					link: '/midwife-birth-kits/',
				},
				{
					img: 'https://store-nuj3c.mybigcommerce.com/product_images/help-center/cropped/kit-service-min-3.png',
					title: 'Setup Custom Birth Kit',
					link: '/new-birth-kit-setup',
				},
			],
		}
	},

	computed: {
		hereToHelp() {
			return [
				{
					img: 'https://store-nuj3c.mybigcommerce.com/product_images/help-center/cropped/chat-min.png',
					title: 'Live Chat',
					action: this.openChatWidget,
					live: true,
					subtitle: 'Start on the right side of your screen',
				},
				{
					img: 'https://store-nuj3c.mybigcommerce.com/product_images/help-center/cropped/text-min.png',
					title: 'Text Us',
					action: this.openMessagesApp,
					message: '512-877-4356',
				},
				{
					img: 'https://store-nuj3c.mybigcommerce.com/product_images/help-center/cropped/email-min.png',
					title: 'Email',
					action: this.openMailApp,
					subtitle: 'Help@inhishands.com',
				},
				{
					img: 'https://store-nuj3c.mybigcommerce.com/product_images/help-center/cropped/call-min.png',
					title: 'Call Us',
					action: this.openDialerApp,
					sub: true,
				},
			]
		},
	},

	methods: {
		openChatWidget() {
			if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
				window.GorgiasChat.open()
			} else {
				setTimeout(this.openChatWidget, 500)
			}
		},
		openMailApp() {
			let subject = ''
			if (this.store?.user?.id) {
				subject = `${this.store?.user?.firstName} ${this.store?.user?.lastName} - ${this.store?.user?.email}`
			}
			window.location.href = `mailto:help@inhishands.com?subject=${encodeURIComponent(subject)}`
		},
		openMessagesApp() {
			window.location.href = 'sms:512-877-4356'
		},
		openDialerApp() {
			window.location.href = 'tel:1-800-247-4045'
		},
	},
}
</script>

<style>
.custom-checkbox input[type='checkbox']:checked ~ .checkmark {
	display: flex;
	@apply bg-ihh-dark-salmon flex border-0;
}
</style>
